const errorMessageStyle = () => ({
  errorMessage: {
    color: 'red',
    paddingTop: '3px',
    paddingLeft: '15px',
    fontFamily: 'Arial',
    fontSize: 'var(--fs-12, 0.75rem)',
  },
})

export default errorMessageStyle
